// Structure based on this guide:
// https://medium.com/@resir014/redux-4-typescript-2-9-a-type-safe-approach-7f073917b803
import { Reducer } from 'redux';

import {
  CityActionTypes as types,
  ICityState,
} from '../types/city';

/* tslint:disable:object-literal-sort-keys */
const initialState: ICityState = {
  name: 'Cityville',
  // City Assumptions
  populationGrowthRate: 0.05, // growth rate per year, 5%
  economicGrowthRate: 0.05,
  passengerDistanceTraveled: 1937, // for now: assume fixed units
  userChoicePercentageBound: 0.5, // not clear where this comes from

  // City Boolean
  hasMajorHills: false,
  hasCngRegulation: false, // natural gas requirement

  // City Stats
  population: 300000,
  grossDomesticProduct: 480000000, // assume in dollars

  // Modal Split of Motorized Vehicles (sum to 1)
  vehicleModalSplit : {
    car: 0.66,
    twoWheel: 0.15,
    threeWheel: 0,
    publicTransit: 0.19
  },

  // Modal split by vehicle ownership
  // Make it flat for now... don't need to sub-analyze private vs commercial til later
  // can derive inverse if needed
  vehicleOwnershipSplit : {
    // Each subgroup grows up to 1... we can unnest it later
    car: {
      private: 0.69,
      commercial: 0.31,
      public: 0,
    },
    autoRickshaw: {
      commercial: 1,
    },
    twoWheel: {
      private: 0.999999,
      commercial: 0.000001,
    },
    publicTransit: {
      bus: 0.79,
      metro: 0.21,
    }
  }
};

const cityReducer: Reducer<ICityState> = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_BOOLEAN_PROP:
    case types.SET_NUMBER_PROP:
    case types.SET_OBJECT_PROP:
      const { propName, value } = payload;
      return { ...state, [propName]: value };
    default:
      return state;
  }
}

export default cityReducer;

// Basic selectors
export const getPopulation = (state: ICityState) => state.population;
export const getPopulationGrowthRate = (state: ICityState) => state.populationGrowthRate;

export const getUserChoicePercentageBound = (state: ICityState) => state.userChoicePercentageBound;

export const getGrossDomesticProduct = (state: ICityState) => state.grossDomesticProduct;
export const getEconomicGrowthRate = (state: ICityState) => state.economicGrowthRate;

export const getPassengerDistanceTraveled = (state: ICityState) => state.passengerDistanceTraveled;

//
export const getModalSplitByType = (state: ICityState) => state.vehicleModalSplit;
export const getModalSplitByOwnership = (state: ICityState) => state.vehicleOwnershipSplit;

//
export const getHasMajorHills = (state: ICityState) => state.hasMajorHills;
export const getHasCngRegulation = (state: ICityState) => state.hasCngRegulation;



// WEBPACK FOOTER //
// ./src/store/reducers/city.ts